import * as S from "./styled";
import logo from "../../assets/Svg/icon.svg";
import React from "react";
import theme from "../../theme";
import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();

    return (
        <S.Container>

            <S.SubContainer>
                <S.Title>
                    {t('footer_agreement_intro')}
                    <br />
                    <a style={{ color: theme.COLORS.PRIMARY }} href="/serviceTerms">
                        {t('footer_terms_of_service')}
                    </a>
                    {t('footer_agreement_comma')}
                    <a style={{ color: theme.COLORS.PRIMARY }} href="/privacyPolicy">
                        {t('footer_privacy_policy')}
                    </a>
                    {t('footer_agreement_end')}
                </S.Title>

                <S.Description>
                    {t('footer_copyright')}
                </S.Description>
            </S.SubContainer>
        </S.Container>
    );
}